import commonBlocks from '../Common';
import {AvailablePlans, BlocksMap, FormBlock} from '../types';
import {AdditionalOptionsandBenefitsGHI3Block} from './GHI3/HIMasterAdditionalOptionsAndBenefitsGHI3';
import {HospitalCareServicesBlock} from './GHI3/HospitalCareServicesV2';
import {HIAdditionalOptionsandBenefitsGIM2Block} from './HIAdditionalOptionsAndBenefitsGIM2';
import {ConfinementBenefitsBlock} from './HIConfinementBenefitsV2';

const GIM2Blocks: FormBlock[] = [
  {FormBlock: ConfinementBenefitsBlock, key: 'confinement-benefits'},
  {FormBlock: HIAdditionalOptionsandBenefitsGIM2Block, key: 'gim2-additional-options-benefits'},
];
const GHI3Blocks: FormBlock[] = [
  {FormBlock: HospitalCareServicesBlock, key: 'hospital-care-services'},
  {FormBlock: AdditionalOptionsandBenefitsGHI3Block, key: 'ghi3-additional-options-benefits'},
];

const hospitalIndemnityBlocksMap: BlocksMap = new Map();

hospitalIndemnityBlocksMap.set('GIM2', GIM2Blocks);
hospitalIndemnityBlocksMap.set('GHI3', GHI3Blocks);

export const getHospitalIndemnityBlocks = (plan: AvailablePlans) =>
  hospitalIndemnityBlocksMap.has(plan) ? [...commonBlocks, ...hospitalIndemnityBlocksMap.get(plan)] : [];
